//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DemoStepperCustomHeader from './demos/DemoStepperCustomHeader.vue'
import DemoStepperTransparentHeader from './demos/DemoStepperTransparentHeader.vue'
import DemoStepperVertical from './demos/DemoStepperVertical.vue'
import DemoStepperWithForm from './demos/DemoStepperWithForm.vue'

export default {
  components: {
    DemoStepperCustomHeader,
    DemoStepperTransparentHeader,
    DemoStepperVertical,
    DemoStepperWithForm,
  },
}
